<template>
  <div class="flex flex-col md:flex-row gap-2 p-2 border rounded-lg bg-gray-50">
    <div class="w-full md:flex-1">
      <input 
        v-model="localOption.text" 
        placeholder="Option text"
        class="w-full p-2 border rounded bg-white focus:ring-2 focus:ring-blue-300 focus:border-blue-500 outline-none text-sm"
        @input="update"
      />
    </div>

    <div class="flex flex-wrap gap-2 items-center w-full md:w-auto">
      <select 
        v-model="localOption.type" 
        class="flex-1 md:flex-none p-2 border rounded bg-white text-sm min-w-[120px]"
        @change="update"
      >
        <option value="radio">Radio Button</option>
        <option value="input">Input Field</option>
      </select>

      <input 
        v-if="localOption.type === 'input'"
        v-model="localOption.unit" 
        placeholder="Unit"
        class="flex-1 md:w-20 p-2 border rounded bg-white text-sm"
        @input="update"
      />

      <!-- Delete Button -->
      <button 
        @click="deleteOption" 
        class="p-1.5 text-red-500 hover:text-red-700 rounded-full hover:bg-red-50"
        title="Delete option"
      >
        <span class="material-icons text-xl md:text-lg">delete</span>
      </button>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';

export default {
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  
  emits: ['update', 'delete'],
  
  setup(props, { emit }) {
    const localOption = ref({ ...props.option });

    watch(
      () => props.option,
      (newVal) => {
        localOption.value = { ...newVal };
      }
    );

    const update = () => {
      emit('update', localOption.value);
    };

    const deleteOption = () => {
      emit('delete', localOption.value.id);
    };

    return {
      localOption,
      update,
      deleteOption
    };
  }
};
</script>

<style scoped>
@media (max-width: 640px) {
  .flex-col > * {
    width: 100%;
  }
  
  input, select {
    width: 100%;
    box-sizing: border-box;
    font-size: 0.95rem;
  }
  
  /* Update unit input width on mobile */
  input[placeholder="Unit"] {
    width: calc(100% - 3rem);
  }
  
  /* Ensure proper spacing */
  .gap-2 {
    gap: 0.75rem;
  }
  
  /* Better padding for touch targets */
  .p-2 {
    padding: 0.75rem;
  }
  
  .material-icons {
    font-size: 1.25rem;
  }
  
  /* Make the delete button more touch-friendly */
  button {
    padding: 0.5rem;
  }
  
  /* Improve spacing between stacked elements */
  .gap-2 {
    gap: 0.5rem;
  }
}
</style>